import styled from 'styled-components'

export default styled.div`
  background: #eb6600;
  color: #fff;
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  left: 0;
  overflow: hidden;
  position: absolute;
  text-align: center;
  top: 0;
  width: 60px;
`
